/* eslint-disable max-len */
import React, { useCallback, useMemo } from 'react';
import { Checkbox, Flex, Pane, Text } from '@leverege/ui-elements';
import { Attributes } from '@leverege/ui-attributes';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function RecovrProductSelector(props) {
  const {
    location,
    eventData,
    value,
    onChange: pOnChange
  } = props;
  const onChange = useCallback(evt => {
    pOnChange({
      data: eventData,
      value: {
        ...value,
        [evt.data]: evt.value
      }
    });
  }, [eventData, pOnChange, value]);
  const products = useMemo(() => {
    const keysEnabled = location.data?.data?.keysEnabled; // Use a stupid hack instead because the atribute needs to be "hidden" Attributes.get( 'location.keysEnabled', 'location', location.data )

    const p = [{
      label: 'RecovR Locator',
      description: 'The RecovR Locator offers vehicle location tracking, theft recovery assistance, and movement alerts.',
      value: 'recovr',
      image: 'https://storage.googleapis.com/recovr-ui-assets/recovr-locator.png'
    }, {
      label: keysEnabled ? 'RecovR Tags' : 'Upgrade to Unlock Keys Tracking',
      description: keysEnabled ? 'RecovR Tags can be sold with each of the vehicle\'s keys and are a great way to locate lost keys.' : /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx(Text, {
          children: "RecovR Tags can be sold with each of the vehicle's keys and are a great way to locate lost keys. Interested in adding them to your product offering?"
        }), /*#__PURE__*/_jsx("a", {
          target: "_blank",
          rel: "noreferrer",
          href: "https://www.recovr.biz/keys",
          children: "Contact us today to learn more!"
        })]
      }),
      value: 'recovrKeys',
      image: 'https://storage.googleapis.com/recovr-ui-assets/recovr-tag.png',
      disabled: keysEnabled !== true
    }].sort((a, b) => {
      if (a.disabled) {
        return 1;
      }
      return a.label > b.label ? 1 : -1;
    });
    return p;
  }, [location]);
  return /*#__PURE__*/_jsx(Pane, {
    variant: "productSelector",
    layout: "flex:colL",
    children: products.map(product => /*#__PURE__*/_jsx(RecovrProductSelectorItem, {
      product: product,
      onChange: onChange,
      value: value
    }, product.value))
  });
}
function RecovrProductSelectorItem(props) {
  const {
    product,
    value,
    onChange
  } = props;
  const {
    image,
    label,
    description,
    value: productValue,
    disabled
  } = product;
  return /*#__PURE__*/_jsx(Pane, {
    variant: disabled ? 'productSelectorItemDisabled|productSelectorItem' : 'productSelectorItem',
    children: /*#__PURE__*/_jsx(Checkbox, {
      eventData: productValue,
      onChange: onChange,
      value: value[productValue] === true,
      disabled: disabled,
      variant: "productSelectorItem",
      label: /*#__PURE__*/_jsxs(Flex, {
        variant: "rowL",
        align: "center",
        children: [/*#__PURE__*/_jsx("img", {
          width: 80,
          height: 80,
          alt: label,
          src: image
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "colM",
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "bodySmallBold",
            children: label
          }), /*#__PURE__*/_jsx(Text, {
            variant: "bodySmall",
            children: description
          })]
        })]
      })
    })
  });
}